module.exports = __webpack_public_path__ + "img/4deposit.44892b46.png";